import { Divider } from 'antd'
import FilterDiv, { FilterText } from 'components/FilterDiv'
import SearchInput from 'components/SearchInput'
import { TableTop } from 'components/UIComponents/TableSearchFilter/Style/style'
import React from 'react'
import styled from 'styled-components'
import SearchIcon from '../../../../../../components/icons/SearchIcon'
import { normalizeBooleanCondition } from '../../../../../../utils/commonFunction'
import ExternalDiv from './ExternalDiv'

const StyledSearchInput = styled(SearchInput)`
  border-right: ${({ hasBorderRight }) =>
    hasBorderRight ? '1px solid #e8e8e8' : 'none'};
  .ant-input-suffix {
    cursor: pointer;
    padding-right: 8px;
  }

  .ant-form-item-control-input {
  }
`

const ExternalSearchFilter = ({
  menu,
  totalCount = 0,
  currentCount = 0,
  searchValue,
  setSearchValue,
  open,
  setOpen,
  placeholder = 'Search by keyword',
  onOpenChange,
  CandidateMenu,

  hasBorderRight,
  doc = false,
  CandidateFilter = 'true',
  isQualifiedTrue = false,
  allIsTrue = true,
  hideSearchIcon = false,
}) => {
  return (
    <TableTop centerVertically border={doc}>
      {CandidateMenu ? (
        <>
          <StyledSearchInput
            width={'80%'}
            placeholder={placeholder}
            bordered={false}
            searchValue={searchValue}
            setSearchValue={setSearchValue}
            hasBorderRight={hasBorderRight}
            suffix={<SearchIcon />}
          />

          <FilterText>
            Showing {currentCount} of {totalCount}
          </FilterText>
        </>
      ) : (
        <>
          {hideSearchIcon ? null : <SearchIcon />}
          <StyledSearchInput
            width={'20%'}
            placeholder={placeholder}
            bordered={false}
            searchValue={searchValue}
            setSearchValue={setSearchValue}
            suffix={<SearchIcon />}
          />

          {!allIsTrue && (
            <>
              <Divider
                type="vertical"
                style={{
                  height: '60px', // Set the desired height
                }}
              />
              {isQualifiedTrue ? (
                <ExternalDiv style={{ width: '60%' }}></ExternalDiv>
              ) : (
                <div style={{ width: '60%' }}></div>
              )}

              <Divider
                type="vertical"
                style={{
                  height: '60px', // Set the desired height
                }}
              />
            </>
          )}

          {CandidateFilter === 'true' && (
            <>
              {allIsTrue && (
                <FilterDiv
                  width={CandidateFilter === 'true' ? '' : '56%'}
                  overlayMenu={menu}
                  open={open}
                  setOpen={setOpen}
                  onOpenChange={onOpenChange}
                  unsetRightBorder={normalizeBooleanCondition(CandidateFilter)}
                />
              )}
              <FilterText style={{ width: '20%' }}>
                Showing {}
                {isNaN(currentCount) ? 0 : currentCount} of {totalCount}
              </FilterText>
            </>
          )}
        </>
      )}
    </TableTop>
  )
}

export default ExternalSearchFilter
